import React, { Component } from 'react'

import Modal from 'react-bootstrap/Modal'

export default class CustomModal extends Component {
  constructor(props) {
    super(props)
    this.state = {
      show: props.show,
    }
  }

  static getDerivedStateFromProps(nextProps, state) {
    return nextProps
  }

  render() {
    return (
      <Modal
        {...this.props}
        className={this.props.className}
        show={this.state.show}
      >
        <Modal.Body>{this.props.children}</Modal.Body>
      </Modal>
    )
  }
}
